<div class="main filtered-product-list">
  <div class="filter">
    <div>
      <div class="input-select">
        <div class="input" (click)="isShowOptions = !isShowOptions">
          <p>{{ filterForm.get('orderBy').value.key | t }}</p>
          <span [ngClass]="{ active: isShowOptions }"></span>
        </div>
        <div class="options" [ngClass]="{ active: isShowOptions }">
          <ul *ngFor="let orderBy of ORDER_BY">
            <li (click)="setOrderBy(orderBy)"
              *ngIf="orderBy.key === 'FILTERED_PRODUCT_LIST.SORT.MATCH_SCORE' && filterType === SEARCH_TYPE.SEARCH">
              <p>
                {{ orderBy?.key | t }}
              </p>
            </li>
            <li (click)="setOrderBy(orderBy)" *ngIf="orderBy.key !== 'FILTERED_PRODUCT_LIST.SORT.MATCH_SCORE'">
              <p>
                {{ orderBy?.key | t }}
              </p>
            </li>
          </ul>
        </div>
      </div>
      <div class="guide-line"></div>
      <div class="filter-summary">
        <img class="filter-icon" src="/assets/images/filter-list.svg" />
        <span class="filtered" [ngClass]="{ active: isUsedFilter }"></span>
        <a class="filter" (click)="onShowFilterModal(true)" [innerHTML]="'TERM.FILTER' | t">Filter</a>
      </div>
    </div>
    <!-- 상품 검색결과 없을 때 -->
  </div>
  <div class="products">
    <ng-container *ngIf="!pagenatedProducts || pagenatedProducts?.items.length === 0">
      <p class="text-nolist">
        {{
          filterType === 'CATEGORY' ? ('FILTERED_PRODUCT_LIST.NO_PRODUCT' | t) : ('FILTERED_PRODUCT_LIST.NOT_MATCH' | t)
        }}
        <a [innerHTML]="'BUTTON.REQUEST_SUPPLY' | t" *ngIf="filterType === 'SEARCH'" (click)="inquiry.open()">입고요청</a>
      </p>
    </ng-container>
    <ul class="product">
      <li *ngFor="let product of pagenatedProducts?.items; let i = index">
        <app-product-single class="ga-ee-product-impression" [product]="product" type="category" [wide]="true"
          [attr.data-name]="product.englishName" [attr.data-id]="product.id"
          [attr.data-price]="product.mapperSaleProducts[0].productOption.salePriceUSD"
          [attr.data-brand]="product.brand.englishName"
          [attr.data-variant]="product.mapperSaleProducts[0].productOption.englishOptionName" [attr.data-position]="i"
          [attr.data-category]="product.salesCategoryCode | categoryName" [attr.data-list]="categoryDataList">
        </app-product-single>
        <!-- [attr.data-category]="categoryData"
        [attr.data-list]="categoryDataList" -->
      </li>
    </ul>
  </div>
  <p-dialog #filterModal [(visible)]="isShowFilterModal" [maximizable]="true" [responsive]="true" [showHeader]="false"
    [draggable]="false" [resizable]="false" [transitionOptions]="'0ms'" (onShow)="initModalMaximized(filterModal)"
    class="main sticky">
    <form [formGroup]="filterForm" (ngSubmit)="onSubmitFilter()">
      <fieldset>
        <header>
          <a class="close" (click)="onSubmitFilter()"></a>
        </header>
        <section class="header">
          <strong [innerHTML]="'TERM.FILTER' | t">Filter</strong>
          <span
            [innerHTML]="'ORDER.COUNT_ITEM' | t: { count: pagenatedProducts?.totalCount }">{{ pagenatedProducts?.totalCount }}
            items</span>
        </section>
        <section class="content">
          <ul>
            <li [class.active]="FILTER_SECTION.SORT === selectedFilterSection">
              <p>
                <strong (click)="onToggleSection(FILTER_SECTION.SORT)" [innerHTML]="'FILTER_SECTION.SORT' | t">{{
                  FILTER_SECTION.SORT
                }}</strong>
                <span>{{ filterForm.get('orderBy').value.key | t }}</span>
              </p>
              <div>
                <mat-radio-group aria-labelledby="order-by-radio-label" class="radio-field" formControlName="orderBy">
                  <ng-container *ngFor="let order of ORDER_BY">
                    <mat-radio-button class="radio-button" [value]="order" *ngIf="
                        order.key === 'FILTERED_PRODUCT_LIST.SORT.MATCH_SCORE' && filterType === SEARCH_TYPE.SEARCH
                      ">
                      {{ order.key | t }}
                    </mat-radio-button>
                  </ng-container>
                  <ng-container *ngFor="let order of ORDER_BY">
                    <mat-radio-button class="radio-button" [value]="order"
                      *ngIf="order.key !== 'FILTERED_PRODUCT_LIST.SORT.MATCH_SCORE'">
                      {{ order.key | t }}
                    </mat-radio-button>
                  </ng-container>
                </mat-radio-group>
              </div>
            </li>
            <li [class.active]="FILTER_SECTION.CATEGORY === selectedFilterSection"
              *ngIf="filterType !== 'CATEGORY' && allDisplayCategories">
              <p>
                <strong (click)="onToggleSection(FILTER_SECTION.CATEGORY)"
                  [innerHTML]="'FILTER_SECTION.CATEGORY' | t">{{ FILTER_SECTION.CATEGORY }}</strong>
                <span>{{ getFilteredCategoryLabel() }}</span>
              </p>
              <div class="category">
                <mat-checkbox class="checkbox" [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="isSelectedAllCategory" (change)="onUncheckedCategoryAll()">
                  <span [innerHTML]="'TERM.ALL' | t">
                    All
                  </span>
                </mat-checkbox>
                <ng-container *ngIf="selected.displayCategoryTree.children?.length > 0">
                  <div class="depth-1" [class.active]="category1.unfolded === true"
                    *ngFor="let category1 of selected.displayCategoryTree.children">
                    <div>
                      <mat-checkbox class="checkbox" [ngModelOptions]="{ standalone: true }"
                        [(ngModel)]="category1.selected" (change)="onToggleCategory(category1, $event)">
                        {{ category1.item.name }}
                      </mat-checkbox>
                      <span *ngIf="category1?.children.length > 0"
                        (click)="category1.unfolded = !category1.unfolded"></span>
                    </div>
                    <ng-container *ngIf="category1?.children.length > 0">
                      <div class="depth-2" [class.show]="category1.unfolded === true"
                        [class.active]="category2.unfolded === true" *ngFor="let category2 of category1.children">
                        <div>
                          <mat-checkbox class="checkbox" [ngModelOptions]="{ standalone: true }"
                            [(ngModel)]="category2.selected" (change)="onToggleCategory(category2, $event)">
                            {{ category2.item.name }}
                          </mat-checkbox>
                          <span *ngIf="category2?.children.length > 0"
                            (click)="category2.unfolded = !category2.unfolded"></span>
                        </div>
                        <ng-container *ngIf="category2?.children.length > 0">
                          <div class="depth-3" [class.show]="category2.unfolded === true"
                            *ngFor="let category3 of category2.children">
                            <div>
                              <mat-checkbox class="checkbox" [ngModelOptions]="{ standalone: true }"
                                [(ngModel)]="category3.selected" (change)="onToggleCategory(category3, $event)">
                                {{ category3.item.name }}
                              </mat-checkbox>
                            </div>
                          </div>
                        </ng-container>
                      </div>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </li>
            <li [class.active]="FILTER_SECTION.BRAND === selectedFilterSection" *ngIf="filterType !== 'BRAND'">
              <p>
                <strong (click)="onToggleSection(FILTER_SECTION.BRAND)" [innerHTML]="'FILTER_SECTION.BRAND' | t">{{
                  FILTER_SECTION.BRAND
                }}</strong>
                <span [innerHTML]="getFilteredBrandLabel()">BrandName</span>
              </p>
              <div>
                <mat-checkbox class="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="isSelectedAllBrand"
                  (change)="onUncheckedBrandAll()">
                  <span [innerHTML]="'TERM.ALL' | t">
                    All
                  </span>
                </mat-checkbox>
                <mat-checkbox class="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="brand.selected"
                  *ngFor="let brand of selected.brands" (change)="isSelectedAllBrand = false">
                  {{ brand.englishName }}
                </mat-checkbox>
              </div>
            </li>
            <li [class.active]="FILTER_SECTION.PRICE_RANGE === selectedFilterSection">
              <p>
                <strong (click)="onToggleSection(FILTER_SECTION.PRICE_RANGE)"
                  [innerHTML]="'FILTER_SECTION.PRICE_RANGE' | t">{{ FILTER_SECTION.PRICE_RANGE }}</strong>
                <span [innerHTML]="getFilteredPriceRangeLabel()"> All</span>
              </p>
              <div>
                <mat-radio-group aria-labelledby="order-by-radio-label" class="radio-field"
                  [(ngModel)]="selected.priceType" [ngModelOptions]="{ standalone: true }">
                  <div>
                    <mat-radio-button class="radio-button" (change)="onChangePriceRange(PRICE_TYPE.ALL)"
                      [value]="PRICE_TYPE.ALL">
                      <span [innerHTML]="'TERM.ALL' | t">
                        All
                      </span>
                    </mat-radio-button>
                  </div>
                  <div>
                    <mat-radio-button class="radio-button" (change)="onChangePriceRange(PRICE_TYPE.PRICE)"
                      [value]="PRICE_TYPE.PRICE">
                      <p>{{ 'TERM.PRICE' | t }} (USD)</p>
                    </mat-radio-button>
                    <fieldset>
                      <div class="field min-max">
                        <div>
                          <label>
                            <input type="text" mask="0{5}" placeholder="&nbsp;" formControlName="minPrice" maxlength="5"
                              (focus)="onChangePriceRange(PRICE_TYPE.PRICE)" />
                            <span [innerHTML]="'TERM.MIN_PRICE' | t">Min</span>
                            <span></span>
                          </label>
                        </div>
                        <span>~</span>
                        <div>
                          <label>
                            <input type="text" mask="0{5}" placeholder="&nbsp;" formControlName="maxPrice" maxlength="5"
                              (focus)="onChangePriceRange(PRICE_TYPE.PRICE)" />
                            <span [innerHTML]="'TERM.MAX_PRICE' | t">Max</span>
                            <span></span>
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div>
                    <mat-radio-button class="radio-button" (change)="onChangePriceRange(PRICE_TYPE.SUPPLY_RATE)"
                      [value]="PRICE_TYPE.SUPPLY_RATE">
                      <p>{{ 'TERM.SUPPLY_RATE' | t }} (%)</p>
                    </mat-radio-button>
                    <fieldset>
                      <div class="field min-max">
                        <div>
                          <label>
                            <input type="text" mask="00" placeholder="&nbsp;" formControlName="minRate" maxlength="2"
                              (focus)="onChangePriceRange(PRICE_TYPE.SUPPLY_RATE)" />
                            <span [innerHTML]="'TERM.MIN_RATE' | t">Min</span>
                            <span></span>
                          </label>
                        </div>
                        <span>~</span>
                        <div>
                          <label>
                            <input type="text" mask="00" placeholder="&nbsp;" formControlName="maxRate" maxlength="2"
                              (focus)="onChangePriceRange(PRICE_TYPE.SUPPLY_RATE)" />
                            <span [innerHTML]="'TERM.MAX_RATE' | t">Max</span>
                            <span></span>
                          </label>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </mat-radio-group>
              </div>
            </li>
            <li [class.active]="FILTER_SECTION.MOQ === selectedFilterSection">
              <p>
                <strong (click)="onToggleSection(FILTER_SECTION.MOQ)" [innerHTML]="'FILTER_SECTION.MOQ' | t">{{
                  FILTER_SECTION.MOQ
                }}</strong>
                <span>{{ getFilteredMoqLabel() }}</span>
              </p>
              <div>
                <p [innerHTML]="'FILTERED_PRODUCT_LIST.MIN_MAX_QUANTITY' | t">
                  Minimum/Maximum Order Quality (units)
                </p>
                <fieldset>
                  <div class="field min-max">
                    <div>
                      <label>
                        <input type="text" maxlength="5" mask="0{5}" placeholder="&nbsp;" formControlName="minMoq" />
                        <span [innerHTML]="'TERM.MIN_MOQ' | t">Min</span>
                        <span></span>
                      </label>
                    </div>
                    <span>~</span>
                    <div>
                      <label>
                        <input type="text" maxlength="5" mask="0{5}" placeholder="&nbsp;" formControlName="maxMoq" />
                        <span [innerHTML]="'TERM.MAX_MOQ' | t">Max</span>
                        <span></span>
                      </label>
                    </div>
                  </div>
                </fieldset>
              </div>
            </li>
            <li [class.active]="FILTER_SECTION.MOA === selectedFilterSection">
              <p>
                <strong (click)="onToggleSection(FILTER_SECTION.MOA)" [innerHTML]="'FILTER_SECTION.MOA' | t">{{
                  FILTER_SECTION.MOA
                }}</strong>
                <span>{{ getFilteredMoaLabel() }}</span>
              </p>
              <div>
                <p [innerHTML]="'FILTERED_PRODUCT_LIST.MIN_MAX_AMOUNT' | t">
                  Minimum/Maximum Order AMOUNT (units)
                </p>
                <fieldset>
                  <div class="field min-max">
                    <div>
                      <label>
                        <input type="text" maxlength="5" mask="0{5}" placeholder="&nbsp;" formControlName="minMoa" />
                        <span [innerHTML]="'TERM.MIN_MOQ' | t">Min</span>
                        <span></span>
                      </label>
                    </div>
                    <span>~</span>
                    <div>
                      <label>
                        <input type="text" maxlength="5" mask="0{5}" placeholder="&nbsp;" formControlName="maxMoa" />
                        <span [innerHTML]="'TERM.MAX_MOQ' | t">Max</span>
                        <span></span>
                      </label>
                    </div>
                  </div>
                </fieldset>
              </div>
            </li>
            <li [class.active]="FILTER_SECTION.CERTIFICATION === selectedFilterSection">
              <p>
                <strong (click)="onToggleSection(FILTER_SECTION.CERTIFICATION)">Certification</strong>
                <span [innerHTML]="getFilteredCerificationLabel().join(', ')"></span>
              </p>
              <div>
                <mat-checkbox
                class="checkbox"
                [ngModelOptions]="{ standalone: true }"
                [(ngModel)]="certificationType.selected"
                *ngFor="let certificationType of certificationTypes"
              >
                <span>
                  {{ certificationType.value }}
                </span>
              </mat-checkbox>

              <mat-checkbox class="checkbox" [ngModelOptions]="{ standalone: true }" [(ngModel)]="isCpnp">
                <span>
                  CPNP
                </span>
              </mat-checkbox>
              </div>
            </li>
          </ul>
        </section>
        <section class="submit cancel-n-done">
          <button type="button" (click)="resetForm()" [innerHTML]="'BUTTON.RESET' | t">RESET</button>
          <button type="submit" [innerHTML]="'BUTTON.DONE' | t">DONE</button>
        </section>
      </fieldset>
    </form>
  </p-dialog>
</div>

<app-inquiry #inquiry [type]="INQUIRY_TYPE.PRODUCT" [isRequestProduct]="true"></app-inquiry>
